<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  allowClear>
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>告警类型</label>
			<a-select  style="width:10rem; margin: 0 0.625rem; font-size: 0.6875rem;" v-model="theAlarm" placeholder="选择告警类型" allowClear label-in-value>
				<a-select-option v-for="(item,index) in alarmTypeList" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
			</a-select>
			<label>表地址</label>
			<a-input placeholder="水表地址" v-model="paramModel.meterAddr" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<a-button  size="small"  icon="search" @click="queryData">查找</a-button>
			
			<a-input-search v-model ="paramModel.theBookNum" placeholder="根据册本号查询"    v-if="check4Wh"
			enter-button @search="queryDataByBookNum"  style="width: 12rem; margin-left: 0.625rem;"/>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="500"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="id">
			<vxe-table-column title="所属小区" field="neighborId"    :formatter="getTheNeighborName"></vxe-table-column>
			<vxe-table-column title="给水号" field="apId"></vxe-table-column>
			<vxe-table-column title="水表地址" field="meterAddr"></vxe-table-column>
			<vxe-table-column title="告警类型" field="alarmType" :formatter="getTheAlarmName"></vxe-table-column>
			<vxe-table-column title="告警内容" field="alarmContent" ></vxe-table-column>
			<vxe-table-column title="告警时间" field="createTime" ></vxe-table-column>
			<vxe-table-column title="操作" field="PID" width="200">
				<template #default="{ row }">
					<a-button   size="small"  type="link"  @click="showHistoryData(row)">历史读数</a-button>
				</template>
			</vxe-table-column>
		</vxe-table>					
		<div style="float: right; margin-top: 1rem;" >
			<a-pagination :current="paramModel.pageNum"  showQuickJumper :show-total="total => `共 ${total} 条`"
				 :pageSize="paramModel.pageSize" :total="paramModel.totalRecords" @change="pageChangeHandler"/>
		</div>
		<a-drawer title="历史读数"  :visible="showHistoryFlag" width="520" @close="showHistoryFlag = false" :destroyOnClose="true"  :maskClosable="true">
			<MeterReadHistory  :theId="theObj.meterId"/>
		</a-drawer>
	</div>
</template>

<script>
	import MeterReadHistory from '../components/MeterReadHistory.vue' 
	export default {
		components:{
			MeterReadHistory,
		},
		data() {
			return {
				dataList:[],
				neighborList: [],
				theNeighbor:undefined,
				theAlarm:undefined,
				paramModel:{
					alarmType:null,
					meterAddr:null,
					neighborId:null,
					pageNum: 1,
					pageSize: 10,
					totalRecords:0,
					theBookNum:null,
				},
				loading:false,
				showHistoryFlag:false,
				theObj:{},
				book:false,
				
			}
		},
		methods: {
			queryDataByBookNum(){
				this.loading = true;
				if(this.paramModel.theBookNum == null || this.paramModel.theBookNum.length == 0){
					return;
				}
				let param = this.getParam();
				let url = this.Api.getLastUrl(this.Api.QUERY_METER_ALARM_LIST_BOOKNUM_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.book = true;
						this.dataList = result.content;
						this.paramModel.totalRecords = result.recordTotal;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			showHistoryData(item){
				this.theObj = this.Config.deepClone(item);
				this.showHistoryFlag = true;
			},
			pageChangeHandler(pageNo,pageSize){
				this.paramModel.pageNum = pageNo;
				this.paramModel.pageSize = pageSize;
				if(this.book){
					this.queryDataByBookNum();
				}else{
					this.queryData();
				}
				
			},
			queryData(){
				this.loading = true;
				let param = this.getParam();
				let url = this.Api.getLastUrl(this.Api.QUERY_METER_ALARM_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result.content;
						this.paramModel.totalRecords = result.recordTotal;
						this.book = false;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getParam(){
				if(this.theNeighbor !=undefined){
					this.paramModel.neighborId = this.theNeighbor.key;
				};
				if(this.theAlarm!=undefined){
					this.paramModel.alarmType = this.theAlarm.key;
				}
				return this.paramModel;
			},
			getTheNeighborName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(cellValue == item.pId){
						result = item.neighborName;
						break;
					}
				}
				return result;
			},
			getTheAlarmName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.alarmTypeList.length;i++){
					let item = this.alarmTypeList[i];
					if(cellValue == item.value){
						result = item.name;
						break;
					}
				}
				return result;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryNeighbors:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
						this.queryData();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created(){
			this.queryNeighbors();
		},
		computed: {
			alarmTypeList(){
				return  this.Config.getAlarmTypeList();
			},
			check4Wh:function(){
				let user = this.Config.getUserLocal();
				if(user.wcId == 37){
					return true;
				}else{
					return false;
				}
			},
		},
	}
</script>

<style>
</style>
